<template>
  <div id="app">
    <section class="banner">
      <div class="container">
        <b class="banner__text"
          >Los estudios se realizan por orden de llegada, sin turno previo</b
        >
      </div>
    </section>

    <nav class="navbar navigation" role="navigation">
      <div class="container">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle"
            data-toggle="collapse"
            data-target=".navbar-ex1-collapse"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-brand" to="/">
            <img
              src="./assets/img/logo-varelab.png"
              alt="Logo"
              class="img-responsive"
          /></router-link>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse navbar-ex1-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li :class="{ active: subIsActive('/institucional') }">
              <a
                href="#"
                class="navbar-dropdown"
                id="institutionalMenu"
                data-toggle="dropdown"
                >Institucional</a
              >
              <ul
                class="dropdown-menu"
                role="menu"
                aria-labelledby="institutionalMenu"
              >
                <li role="presentation">
                  <router-link
                    to="/institucional/estandares"
                    role="menuitem"
                    tabindex="-1"
                    href="#"
                    >Estándares de Calidad</router-link
                  >
                </li>
                <li role="presentation">
                  <router-link
                    to="/institucional/trayectoria"
                    role="menuitem"
                    tabindex="-1"
                    href="#"
                    >Trayectoria</router-link
                  >
                </li>
              </ul>
            </li>
            <li :class="{ active: subIsActive('/servicios') }">
              <a
                href="#"
                class="navbar-dropdown"
                id="servicesMenu"
                data-toggle="dropdown"
                >Servicios</a
              >
              <ul
                class="dropdown-menu"
                role="menu"
                aria-labelledby="servicesMenu"
              >
                <li role="presentation">
                  <router-link
                    to="/servicios/estudios"
                    role="menuitem"
                    tabindex="-1"
                    href="#"
                    >Estudios</router-link
                  >
                </li>
                <li role="presentation">
                  <router-link
                    to="/servicios/extracciones"
                    role="menuitem"
                    tabindex="-1"
                    href="#"
                    >Extracciones</router-link
                  >
                </li>
              </ul>
            </li>

            <!--  <li>
						<router-link to="/institucional">Institucional</router-link>
					</li>
					<li>
						<a href="#" data-toggle="collapse" data-target="#servicios"
							 v-bind:class="{ current: showSubmenu }"
							 v-on:click="showSubmenu = !showSubmenu">Servicios</a>
					</li>
					-->
            <li>
              <router-link to="/coberturas">Coberturas</router-link>
            </li>
            <li>
              <router-link to="/novedades">Novedades</router-link>
            </li>
            <li>
              <router-link
                to="/#contacto"
                v-smooth-scroll="{ duration: 1200, offset: -100 }"
                >Contacto</router-link
              >
            </li>
            <li class="text-center">
              <a
                href="#"
                data-toggle="modal"
                data-target="#solicitarModal"
                class="button button--boston-blue text-center"
              >
                Solicitar el resultado
                <br />de su estudio por mail</a
              >
            </li>
          </ul>
        </div>
        <!-- /.navbar-collapse -->
      </div>
    </nav>
    <div id="servicios" class="actions--upper" v-show="$route.path !== '/'">
      <div class="container">
        <div class="row no-gutter">
          <div class="col-sm-4">
            <router-link to="/servicios/estudios" class="actions--upper__block">
              <div class="inner">
                <div class="icon icon-studies"></div>
                ¿Que estudios realizamos?
              </div>
            </router-link>
          </div>
          <div class="col-sm-4">
            <router-link to="/servicios/dudas" class="actions--upper__block">
              <div class="inner">
                <div class="icon icon-order"></div>
                ¿Dudas con tu orden médica?
              </div>
            </router-link>
          </div>
          <div class="col-sm-4">
            <router-link
              to="/servicios/preguntas"
              class="actions--upper__block"
            >
              <div class="inner">
                <div class="icon icon-question"></div>
                Preguntas frecuentes
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- the router outlet, where all matched components would ber viewed -->
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <div id="solicitarModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal__wrapper">
          <div class="close-btn" data-dismiss="modal">
            <div class="icon-bar"></div>
          </div>
          <h3 class="title md">
            Solicitar el resultado de su estudio por mail
          </h3>

          <p class="color--blue">
            Para poder entregar el resultado de su estudio por mail necesitamos
            que nos envíe los siguientes datos.
          </p>

          <form
            @submit.prevent="requestResults"
            id="requestForm"
            role="form"
            class="form"
            enctype="multipart/form-data"
          >
            <div class="form-group">
              <input
                type="text"
                v-model="requestForm.form.dni"
                class="form-control"
                name="dni"
                id=""
                placeholder="DNI del Solicitante*"
                required
              />
            </div>
            <div v-if="requestForm.errors.dni" class="text-danger form-group">
              {{ requestForm.errors.dni[0] }}
            </div>
            <div class="form-group">
              <input
                type="text"
                v-model="requestForm.form.email"
                class="form-control"
                name="email"
                id=""
                placeholder="Correo electrónico*"
                required
              />
            </div>
            <div v-if="requestForm.errors.email" class="text-danger form-group">
              {{ requestForm.errors.email[0] }}
            </div>
            <div class="form-group">
              <datepicker
                v-model="requestForm.form.realization"
                name="realization"
                language="es"
                :placeholder="'Fecha de Realización del Estudio*'"
                :input-class="'form-control'"
              ></datepicker>
            </div>
            <div
              v-if="requestForm.errors.realization"
              class="text-danger form-group"
            >
              {{ requestForm.errors.realization[0] }}
            </div>
            <div class="form-group">
              <input
                type="text"
                v-model="requestForm.form.protocol"
                class="form-control"
                name="protocol"
                id=""
                placeholder="N° de Protocolo del Estudio Solicitado"
              />
            </div>
            <div class="text-right"><i>*Datos obligatorios</i></div>
            <div class="text-center">
              <div v-if="!requestForm.sended">
                <div v-if="!requestForm.sending">
                  <button type="submit" class="button">Enviar</button>
                </div>
                <div v-else>
                  <div class="button">Enviando ...</div>
                </div>
              </div>
              <div v-else>
                <div class="text-center">
                  <p><b>¡Su mensaje ha sido enviado!</b></p>
                  <p>Pronto estaremos atendiendo su solicitud.</p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div id="cvModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal__wrapper">
          <div class="close-btn" data-dismiss="modal">
            <div class="icon-bar"></div>
          </div>
          <h3 class="title">Forma Parte de Varelab</h3>

          <p class="color--blue">
            Si querés trabajar con nosotros, completa el siguiente formulario.
          </p>

          <form @submit.prevent="cvFormRequest" role="form" class="form">
            <div class="form-group">
              <input
                required
                v-model="cvForm.form.full_name"
                type="text"
                class="form-control"
                id=""
                placeholder="Nombre y Apellido*"
              />
            </div>
            <div v-if="cvForm.errors.full_name" class="text-danger form-group">
              {{ cvForm.errors.full_name[0] }}
            </div>
            <div class="form-group">
              <input
                required
                v-model="cvForm.form.email"
                type="text"
                class="form-control"
                id=""
                placeholder="Email*"
              />
            </div>
            <div v-if="cvForm.errors.email" class="text-danger form-group">
              {{ cvForm.errors.email[0] }}
            </div>
            <div class="form-group">
              <input
                required
                v-model="cvForm.form.address"
                type="text"
                class="form-control"
                id=""
                placeholder="Dirección*"
              />
            </div>
            <div v-if="cvForm.errors.address" class="text-danger form-group">
              {{ cvForm.errors.address[0] }}
            </div>
            <div class="form-group">
              <input
                required
                v-model="cvForm.form.location"
                type="text"
                class="form-control"
                id=""
                placeholder="Localidad*"
              />
            </div>
            <div v-if="cvForm.errors.location" class="text-danger form-group">
              {{ cvForm.errors.location[0] }}
            </div>
            <div class="form-group">
              <input
                required
                v-model="cvForm.form.specialty"
                type="text"
                class="form-control"
                id=""
                placeholder="Especialidad*"
              />
            </div>
            <div v-if="cvForm.errors.specialty" class="text-danger form-group">
              {{ cvForm.errors.specialty[0] }}
            </div>
            <div class="text-right"><i>*Datos obligatorios</i></div>

            <div class="text-center">
              <label class="file-select">
                <div class="button button--inverse">
                  <span v-if="cvForm.form.cv_file">Cambiar archivo</span>
                  <span v-else>Adjuntar archivo</span>
                </div>
                <p class="text-center" v-if="cvForm.form.cv_file">
                  Archivo seleccionado: {{ cvForm.form.cv_file.name }}
                </p>
                <input type="file" @change="onCvChange" />
              </label>

              <div
                v-for="error in cvForm.errors.cv_file"
                class="text-danger form-group"
              >
                {{ error }}
              </div>

              <div v-if="!cvForm.sended">
                <div v-if="!cvForm.sending">
                  <button type="submit" class="button">Enviar</button>
                </div>
                <div v-else>
                  <div class="button">Enviando ...</div>
                </div>
              </div>
              <div v-else>
                <div class="text-center">
                  <p><b>¡Su mensaje ha sido enviado!</b></p>
                  <p>Pronto estaremos revisando su solicitud.</p>
                </div>
              </div>
              <br />
            </div>
          </form>
        </div>
      </div>
    </div>

    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-3">
            <img src="./assets/img/logo-varelab-white.png" alt="Logo blanco" />
            <ul class="footer__contact">
              <li class="location">
                Tte. Gral. Juan D. Perón 1004,
                <br />Florencio Varela
              </li>
              <li class="phone">4287 6172</li>
              <li class="whatsapp">11 3919-8027</li>
              <li class="mail">
                <a class="color--white" href="mailto:info@varelab.com.ar"
                  >info@varelab.com.ar</a
                >
              </li>
              <li class="fb inline-block">
                <a
                  class="color--white"
                  href="https://www.facebook.com/LaboratorioVarelab/"
                  target="_blank"
                  >Varelab</a
                >
              </li>
              <li class="ig inline-block">
                <a
                  class="color--white"
                  href="https://www.instagram.com/laboratoriovarelab/"
                  target="_blank"
                  >laboratoriovarelab</a
                >
              </li>
            </ul>
          </div>
          <div class="col-sm-9">
            <div class="p-top-30">
              <div class="hbox">
                <div class="flex">
                  <a href="" class="color--white text-uppercase"
                    >Institucional</a
                  >
                  <ul style="padding-left: 5px">
                    <li>
                      <router-link
                        to="/institucional/estandares"
                        class="color--white"
                        >Estándares de calidad</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        to="/institucional/trayectoria"
                        class="color--white"
                        >Trayectoria</router-link
                      >
                    </li>
                  </ul>
                </div>
                <div class="flex">
                  <a href="" class="color--white text-uppercase">Servicios</a>
                  <ul style="padding-left: 5px">
                    <li>
                      <router-link to="/servicios/estudios" class="color--white"
                        >Estudios</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        to="/servicios/extracciones"
                        class="color--white"
                        >Extracciones</router-link
                      >
                    </li>
                  </ul>
                </div>
                <div class="flex">
                  <router-link
                    to="/coberturas"
                    href=""
                    class="color--white text-uppercase"
                    >Coberturas</router-link
                  >
                </div>
                <div class="flex">
                  <router-link
                    to="/novedades"
                    href=""
                    class="color--white text-uppercase"
                    >Novedades</router-link
                  >
                </div>
                <div class="flex">
                  <router-link
                    to="/servicios/dudas"
                    href=""
                    class="color--white text-uppercase"
                    >Dudas con tu orden</router-link
                  >
                </div>
                <div class="flex">
                  <router-link
                    to="/servicios/preguntas"
                    class="color--white text-uppercase"
                    >Preguntas frecuentes</router-link
                  >
                </div>
                <div class="flex">
                  <router-link
                    to="/#contacto"
                    class="color--white text-uppercase"
                    >Contacto</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div class="bottom">
      <div class="container">
        <div class="text-right">
          <div class="pull-left">
            <b>2018 &copy;Varelab</b>
            Todos los derechos reservados
          </div>
          <a href="http://www.estudiogema.com" target="_blank">
            <img :src="require('./assets/img/logo-gema.png')" alt="Gema Logo"
          /></a>
        </div>
      </div>
    </div>
    <whatsapp-widget />
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import FileSelect from "./components/Formulario/FileSelect.vue";
import WhatsappWidget from "./components/Partials/WhatsappWidget.vue";

export default {
  name: "app",
  components: {
    Datepicker,
    FileSelect,
    WhatsappWidget,
    WhatsappWidget
  },
  data() {
    return {
      requestForm: {
        sended: false,
        sending: false,
        allow: true,
        errors: [],
        form: {
          dni: null,
          email: null,
          realization: null,
          protocol: null
        }
      },
      cvForm: {
        sended: false,
        sending: false,
        allow: true,
        errors: [],
        form: {
          cv_file: null,
          full_name: null,
          email: null,
          address: null,
          location: null,
          specialty: null
        }
      }
    };
  },
  methods: {
    requestResults: function() {
      this.requestForm.errors = [];
      this.requestForm.sending = true;
      this.$http
        .post("form/request", JSON.stringify(this.requestForm.form))
        .then(
          response => {
            console.log(response.body.success);
            if (response.body.success) {
              this.requestForm.sended = true;
            }
            if (response.body.error) {
              this.requestForm.errors = response.body.error;
            } else if (response.body.messages) {
              this.requestForm.errors = response.body.messages;
              console.log(this.requestForm.errors);
            }

            this.requestForm.sending = false;
          },
          response => {
            if (response.body.error) {
              this.requestForm.errors = response.body.error;
            }
          }
        );
    },
    cvFormRequest: function() {
      this.cvForm.errors = [];
      this.cvForm.sending = true;
      var form_data = new FormData();

      for (var field in this.cvForm.form) {
        if (this.cvForm.form[field] != null) {
          form_data.append(field, this.cvForm.form[field]);
        }
      }

      this.$http
        .post("http://www.varelab.com.ar/api/public/api/form/cv", form_data)
        .then(
          response => {
            console.log(response.body.success);
            if (response.body.success) {
              this.cvForm.sended = true;
            }
            if (response.body.error) {
              this.cvForm.errors = response.body.error;
            } else if (response.body.messages) {
              this.cvForm.errors = response.body.messages;
              console.log(this.cvForm.errors);
            }

            this.cvForm.sending = false;
          },
          response => {
            if (response.body.error) {
              this.cvForm.errors = response.body.error;
            }
          }
        );
    },
    onCvChange: function(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.cvForm.form.cv_file = files[0];
    },
    removeCv: function(e) {
      this.cvForm.form.cv_file = "";
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    }
  }
};
</script>
<!-- styling for the component -->
<style>
.file-select > input[type="file"] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue